//ResultBar2.vue



/* eslint-disable no-undef */
<template>

<!-- Title -->
<!-- ------------------------------------------------------------------------------------------------------------- -->
<div id="title-container">
	<div id="title">
		<input type="checkbox" name="collapse" id="checkbox-collapse-result" class="checkbox-collapse" value="false" @click="$emit('collapseResultBarClicked'), rotate = ! rotate">
		<label for="checkbox-collapse-result" class="lbl-checkbox-collapse">
			<div class="display-icon">
				<i id="arrow-result" class="fas fa-chevron-down"></i>
				<!-- <i class="fa-solid fa-bars"></i> -->
			</div>
		</label>
		<div id="title-text" @click="$emit('collapseResultBarClicked'), rotate = ! rotate">
			Results
		</div>
		<button id="check-button" @click="$emit('checkResultsClicked')">
			Check  
			<!-- <i id="check-icon" class="fas fa-solid fa-check"></i> -->
		</button>		
	</div>
</div>


<div id="bar" v-if="rotate">
<!-- <div id="bar"> -->

	<!-- Title -->
	<!-- ------------------------------------------------------------------------------------------------------------- -->
	<div id="title-placeholder">
	</div>

	<!-- Results -->
	<!-- ------------------------------------------------------------------------------------------------------------- -->
	<div id="results" v-if="rotate">
		<div class="box">
			<div class="box-title">
				Results
			</div>

			<!-- Surface Area -->
			<div class="result-fields">
				<p class="result-text">Surface Area</p>
				<label for="result-text" id="surface-area-value" class="result-value">
					{{ buildingResult.surfaceArea }}					
				</label>
				<p class="result-unit">m&sup2;</p>
			</div>

			<!-- Clear Floor Height -->
			<div class="result-fields">
				<p class="result-text">Clear Floor Height</p>
				<label for="result-text" id="floor-height-value" class="result-value">
					{{ parseFloat(buildingResult.clearFloorHeight).toFixed(2).toString().replace('.', ',') }}
				</label>
				<p class="result-unit">m</p>
			</div>

			<!-- Structural Ceiling Height -->
			<div class="result-fields">
				<p class="result-text">Structural Ceiling Height</p>
				<label for="result-text" id="ceiling-heightvalue" class="result-value">
					{{ parseFloat(buildingResult.structCeilingHeight).toFixed(2).toString().replace('.', ',') }} 
				</label>
				<p class="result-unit">m</p>
			</div>

			<!-- Weight -->
			<div class="result-fields">
				<p class="result-text">Weight</p>
				<label for="result-text" id="weight-value" class="result-value">
					{{ buildingResult.weight }}
				</label>
				<p class="result-unit">kN</p>
			</div>

			<!-- Construction Costs -->
			<div class="result-fields">
				<p class="result-text">Construction Costs</p>
				<label for="result-text" id="costs-value" class="result-value">
					{{ (parseFloat(buildingResult.cost / buildingResult.surfaceArea).toFixed(1)).toString().replace('.', ',') }}
				</label>
				<p class="result-unit">EUR / m&sup2;</p>
			</div>

			<!-- Embodied Carbon -->
			<div class="result-fields">
				<p class="result-text">Embodied Carbon</p>
				<label for="result-text" id="carbon-value" class="result-value">
					{{ (parseFloat(buildingResult.carbonData.total / buildingResult.surfaceArea).toFixed(1)).toString().replace('.', ',') }}
				</label>
				<p class="result-unit">kg CO&#8322;e / m&sup2;</p>
			</div>

		</div>

	</div>


	<!-- Separating Line -->
	<hr class="separate-line" v-if="rotate"/>


	<!-- Carbon  -->
	<!-- ------------------------------------------------------------------------------------------------------------- -->
	<div id="carbon" v-if="rotate">
		
		<div class="box">
			<div class="box-title">
				Carbon Chart
				<p class="chart-unit">[kg CO&#8322;e]</p>
			</div>
			<CarbonPieChart id="carbon-chart" :carbon-data="carbonData"/>
		</div>

	</div>


	<!-- Separating Line -->
	<hr class="separate-line" v-if="rotate"/>


	<!-- Recycling -->
	<!-- ------------------------------------------------------------------------------------------------------------- -->
	<div id="recycling" v-if="rotate">
		<div class="box">
			<div class="box-title">
				Recycling Chart
				<p class="chart-unit">[m&sup3;]</p>
			</div>

			<!-- Selector -->
			<div id="selector" @click="showRecycleSelect = ! showRecycleSelect">
				<p>{{ recycleSelectText }}</p>
				<i id="arrow-select-down" class="fas fa-chevron-down" v-if="!showRecycleSelect" ></i>
				<i id="arrow-select-up"   class="fas fa-chevron-up"   v-if="showRecycleSelect"  ></i>
			</div>

			<ul id="recycle-list" v-if="showRecycleSelect">
				<li class="option" id="option-mrc" @click="recycleMRCClicked">MRC</li>
				<li class="option" id="option-meol" @click="recycleMEoLClicked">MEoL</li>
			</ul>

			<!-- Charts -->
			<RecyclingMRCPieChart id="recycle-mcr-chart" v-if="recycleMCR" :material-recycling-content="materialRecyclingContent"/>
			<RecyclingMEoLPieChart id="recycle-meol-chart" v-if="!recycleMCR" :material-end-of-life="materialEndOfLife"/>
		
		</div>

	</div>


	<!-- Separating Line -->
	<hr class="separate-line" v-if="rotate"/>


	<!-- Counter -->
	<!-- ------------------------------------------------------------------------------------------------------------- -->
	<div id="counter" v-if="rotate"> 

		<div id="counter-number" v-if="this.$store.state.counter >= 1">
			{{ this.$store.state.counter}}
		</div>

		<div class="container-icon"  v-if="this.$store.state.counter >= 1">
			<img class="icon" src="imgs/icons/building.svg">
		</div>
		
		<div class="container-variant-text"  v-if="this.$store.state.counter >= 1">
			Variants
			<div id="variant-count">
				{{ this.$store.state.counter}} Variants saved 
			</div>
		</div>

	</div>


	<!-- Buttons -->
	<!-- ------------------------------------------------------------------------------------------------------------- -->
	<div id="buttons" v-if="rotate">

		<button class="result-button" id="save-variant" @click="$emit('saveVariantClicked')">
			Save Variant
		</button>

		<button class="result-button" id="visualize-variant" @click="$emit('visualizeGeometryClicked')">
			Visualize
		</button>

		<button class="result-button" id="compare-variants" @click="$emit('compareVariantsClicked')">
			Compare Variants
		</button>

	</div>

	<!-- <div v-if="!this.$store.state.showResultBar" id="vertical-text-result">
		Result
	</div> -->

</div>
	
</template>

<script>


//Import Components,
import CarbonPieChart from './CarbonPieChart.vue';
import RecyclingMRCPieChart from './RecyclingMRCPieChart.vue';
import RecyclingMEoLPieChart from './RecyclingMEoLPieChart.vue';


import gsap from "gsap";


export default {
	components: {
		CarbonPieChart,
		RecyclingMRCPieChart,
		RecyclingMEoLPieChart
	},
	emits: [
			'saveVariantClicked',
			'visualizeGeometryClicked',
			'compareVariantsClicked',
			'checkResultsClicked',
			'collapseResultBarClicked'
	],
	props:
	// [
		{
			buildingResult: Object,
			rotateResult: Boolean
		},

	// ],
	
	// {
	// 	buildingResult: Object,
	// },
	data() {
		return {
			surfaceArea: "-",
			far: "-",
			floorHeight: "-",
			weight: "-",
			cost: "-",
			carbon: "-",
			renderChart: false,
			rotate: false,
			showResult: true,
			showRecycle: true,
			showRecycleSelect: false,
			recycleMCR: true,
			recycleSelectText: "MRC",
			carbonData: this.buildingResult.carbonData,
			materialRecyclingContent: this.buildingResult.materialRecyclingContent,
			materialEndOfLife: this.buildingResult.materialEndOfLife,
			buildingResultDeep: this.buildingResult
		}; 
	}, 
	methods: {
		recycleMRCClicked() {
			console.log('recycleMRCClicked');
			this.recycleSelectText = 'MCR';
			this.recycleMCR = true;
			this.showRecycleSelect = false;
		},
		recycleMEoLClicked() {
			console.log('recycleMEoLClicked');
			this.recycleSelectText = 'MEoL';
			this.recycleMCR = false;
			this.showRecycleSelect = false;
		}
	},
	mounted() {
		// console.log('rotateResult from result bar');
		// console.log(this.rotateResult);
		this.rotate = this.rotateResult;
	},
	watch: {
		rotate: {
			handler() {
				var arrow = document.getElementById('arrow-result'); 
				// var verticalText = document.getElementById('vertical-text-result'); 

				if(this.rotate) {
					gsap.to(arrow, { duration: .4,  rotate: (180), transformOrigin:"center" });
				}

				if(!this.rotate) {
					gsap.to(arrow, { duration: .4,  rotate: (0), transformOrigin:"center" });
				}
			}
		},
		rotateResult: {
			handler() {
				// console.log("rotateResult from watcher");
			}
		}

		// "$store.state.showResultBar" : {
		// 	deep: true, 
		// 	handler() {
		// 		console.log('rotate result changed');

		// 		var arrow = document.getElementById('arrow-result'); 
		// 		var verticalText = document.getElementById('vertical-text-result'); 

		// 		if(this.$store.state.showResultBar) {
		// 			gsap.to(arrow, { duration: .4,  rotate: (180)});
		// 			gsap.to(verticalText, { duration: .1,  opacity: (0)});
		// 		}

		// 		if(!this.$store.state.showResultBar) {
		// 			gsap.to(arrow, { duration: .4,  rotate: (0)});
		// 			gsap.to(verticalText, { duration: .8,  opacity: (1)});
		// 		}
		// 	},
		// }
	}
	
};
</script>



<style scoped>



#bar {
	/* border: 1px solid black; */
	width: 22vw;
	min-width: 300px;
	height: 84vh;
	border-radius: 20px 20px 20px 20px;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	/* background: white; */
	background: transparent;
	backdrop-filter: blur(5px);
}

/* -----------------------------------------------------------------------------------------------------
Title
------------------------------------------------------------------------------------------------------- */
#title-placeholder {
	height: 7%;
}

#title-container {
	position: fixed;
	z-index: 100;
	top: 11.2%;
	left: 78.4%;
	/* border: 1px solid black; */
	height: 7%;
	width: 16vw;
	/* width: 10%; */
	margin: 0;
	/* background: black; */
	background: transparent;
	/* border-radius: 20px 20px 0px 0px; */
	display: flex;
	/* justify-content: space-between; */
	line-height: 100%;
}

#title {
	/* color: white;	 */
	color: rgba(0, 0, 0, 1);
	font-family: 'Lato', sans-serif;
	/* border: 1px solid rgba(255, 255, 255, 1); */
	top: 26%;
	left: 10%;
	position: relative;
	font-size: 1.45rem;
	/* width: 100%; */
	display: flex;
}

#title-text {
	/* border: 1px solid rgba(255, 255, 255, 1); */
	cursor: pointer;
}

.checkbox-collapse {
	display: none;
}

.lbl-checkbox-collapse {
	/* border: 1px solid rgba(255, 255, 255, 1); */
	margin-top: -1%;
	margin-left: -2%;
	margin-right: 5%;
	display: flex;
	cursor: pointer;
}

#arrow-result {
	font-size: .8rem;
}

#check-button {
	text-decoration: underline;
	/* border-radius: 14px; */
	height: 20%;
	/* min-width: 30px;
	max-width: 120px; */
	margin-left: 4%;
	margin-top: 1.6%;
	background: transparent;
	border: solid 1px rgba(0, 0, 0, 0);
	/* color: rgba(255, 255, 255, 0.7); */
	color: rgba(0, 0, 0, 0.3);
	cursor: pointer;
	/* font-family: Roboto; */
	font-family: 'Roboto', sans-serif;
	font-weight: 400;
	display: flex;
	/* line-height: 100%; */
	/* box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3); */
}

#check-button:hover {
	transition: 0.1s ease-in;
	background: transparent;
	color: rgba(0, 0, 0, .8);
	font-weight: 500;
}

#check-icon {
	margin: 2px 5px; 
}

/* -----------------------------------------------------------------------------------------------------
Separating Line
------------------------------------------------------------------------------------------------------- */

.separate-line {
	width: 85%;
	color: rgba(0, 0, 0, 0.7);
	border-top: 1px solid rgba(0, 0, 0, 0.2);
	margin: .4rem 1.6rem;
	/* border-radius: 2px; */
}


/* -----------------------------------------------------------------------------------------------------
Boxes
------------------------------------------------------------------------------------------------------- */

#results {
	border: 1px solid transparent;
	height: 26%;
	margin: 0;
	padding: 0% 5%;
}

#carbon {
	/* border: 1px solid black; */
	height: 22%;
	margin: 0;
	padding: 0% 5%;
}

#recycling {
	/* border: 1px solid black; */
	height: 20%;
	margin: 0;
	padding: 0% 5%;	
}

#counter {
	/* border: 1px solid black; */
	height: 6%;
	margin: 0;	
}

#buttons {
	/* border: 1px solid black; */
	height: 6%;
	margin: 0;	
}

.box {
	/* border: 1px solid rgba(0, 0, 0, 0.3); */
	height: 100%;
	/* border-radius: 10px; */
	margin: 0;
	padding: 0;
}

.box-title {
	display: inline-flex;
	margin: 0 3%;
	/* border: 1px solid rgba(0, 0, 0, 0.3); */
	font-size: .70rem;
	/* font-size: 12px; */
	font-weight: 600;
	text-transform: uppercase;
	color: rgba(0, 0, 0, .9);
	width: 50%;
	height: 5%;
}

.chart-unit {
	/* border: 1px solid rgba(0, 0, 0, 0.3);  */
	/* margin: 3%; */
	position: relative;
	top: 0;
	margin-top: 0;
	margin-left: 10%;
	text-transform: initial;
	font-weight: 300;
	color: rgba(0, 0, 0, .5);
}


/* -----------------------------------------------------------------------------------------------------
Results
------------------------------------------------------------------------------------------------------- */

.result-fields {
	/* border: 1px solid black; */
	font-size: .65rem;
	font-weight: 400;
	text-transform: uppercase;
	width: 95%;
	height: 12%;
	/* margin: 0% 5%; */
	/* color: rgba(130, 130, 130, 1); */
	color: rgba(63, 63, 63,1);
	display: flex;
	align-items: center;
	margin: auto;
	/* letter-spacing: .0425rem; */
}


.result-text{
	width: 170%; 
	height: 1.2rem;
	line-height: 1.2rem;
	/* border: 1px solid black; */
	/* letter-spacing: .0425rem; */
	letter-spacing: 0rem;
	vertical-align: middle;
}

.result-value {
	/* display: flex; */
	height:  1.2rem;
	line-height:  1.2rem;
	width: 40%;
	/* border: 1px solid black; */
	text-align: right;
}

.result-unit{
	width: 70%;
	margin-left: 4%;
	/* border: 1px solid black; */
	height: 1.2rem;
	line-height: 1.2rem;
	vertical-align: middle;
	color: #303030;
	text-align: left;
	/* display: inline-block; */
}


/* -----------------------------------------------------------------------------------------------------
Carbon
------------------------------------------------------------------------------------------------------- */

#carbon-chart {
	position: relative;
	top: 8%;
	left: -15%;
	margin-top: -45%;
	margin-left: -6%;
}


/* -----------------------------------------------------------------------------------------------------
Recycling
------------------------------------------------------------------------------------------------------- */

#recycling {
	position: relative;
}

#selector {
	/* border: 1px solid black; */
	position: absolute;
	top: -5.5%;
	left: 60%;
	width: 12%;
	display: flex;
	color: rgba(0, 0, 0, 0.7);
	font-weight: 400;
	font-size: .8rem;
	height: 20%;
	align-content: center;
	vertical-align: middle;
	cursor: pointer;
	z-index: 500;
}

#selector:hover {
	/* text-decoration: underline; */
	font-weight: 500;
}

#recycle-list {
	position: absolute;
	top: -6.5%;
	left: 60%;
	list-style: none;
	font-weight: 400;
	font-size: .8rem;
	/* border: 1px solid black; */
	margin-left: 5%;
	z-index: 100;
}

.option{
	background: rgba(0, 0, 0, 0.9);
	background: rgba(255, 255, 255, 0.4);
	background: transparent;
	padding: 2px 8px 2px 12px;
	z-index: 100;
	font-weight: 300;
	font-size: .70rem;
	color: white;
	color:  rgba(0, 0, 0, 0.8);
	width: 70%;
	text-align: center;
}

#option-mrc {
	border-radius: 5px 5px 0px 0px;
	border: 1px solid rgba(255, 255, 255, 0.7);
}

#option-meol {
	border-radius: 0px 0px 5px 5px;
	border: 1px solid rgba(255, 255, 255, 0.7);
}

.option:hover{
	/* background: rgba(0, 0, 0, 0.1); */
	/* text-decoration: underline; */
	cursor: pointer;
	/* color: #3f3f3f; */
	/* background: rgba(0, 0, 0, 0.7); */
	background: rgba(255, 255, 255, 0.3);
	transition: 0.1s;
	font-weight: 500;
}

#arrow-select-up {
	transform: scale(0.8);
	margin-top: 30%;
	margin-left: 10%;
}

#arrow-select-down {
	transform: scale(0.8);
	margin-top: 30%;
	margin-left: 10%;
}

#recycle-mcr-chart {
	/* border: 1px solid black; */
	position: relative;
	top: 8%;
	left: -15%;
	margin-top: -45%;
	margin-left: -6%;
	z-index: 9;
}

#recycle-meol-chart {
	/* border: 1px solid black; */
	position: relative;
	top: 8%;
	left: -15%;
	margin-top: -45%;
	margin-left: -6%;
}

/* -----------------------------------------------------------------------------------------------------
Counter
------------------------------------------------------------------------------------------------------- */
#counter{
	/* border: 1px solid black; */
	margin-top: 3.5%;
	margin-left: 5%;
	display: flex;
}

#counter-number {
	margin-left: 5%; 
	margin-right: 5%; 
	margin-top: 2%;
	font-size: 1.5rem;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.8);
	/* color: rgba(37, 84, 255, 0.8); */
	/* color: rgba(245, 170, 113, 1); */
}

.container-icon {
	height: 80%;
	width: 9%;
	margin-top: 1%;
	/* width: 40px; */
	border-radius: 10px;
	background: rgba(0, 0, 0, 0.8);
	/* background: rgba(37, 84, 255, 0.8); */
	/* background: rgba(245, 170, 113, 1); */
}

.icon {
	height: 45%;
	top: 25%;
	left: 25%;
	position: relative;
}

.container-variant-text {
	text-align: left;
	margin-left: 4%;
	margin-top: 1%;
	font-size: 0.85rem;
	font-weight: 600;		
	text-transform: uppercase;
	letter-spacing: 1px;
	color: rgb(80, 80, 80);
}

#variant-count {
	margin-top: 4%;
	font-size: 0.6rem;
	font-weight: 500;
	color: rgb(134, 134, 134);
}


/* -----------------------------------------------------------------------------------------------------
Buttons
 ------------------------------------------------------------------------------------------------------- */
#buttons{
	/* border: 1px solid black; */
	margin-left: 5%;
	margin-top: 3.5%;
	position: relative;
}

/* .result-button {
	width: 26%;
	min-width: 80px;
	height: 2.6rem;
	padding: .7rem;
	border-radius: 2rem;
	border: 1px solid black;
	background: transparent;
	margin-top: 0%;
	margin-left: 2%;
	font-weight: 300;
	font-size: .75rem;
	color: rgba(0, 0, 0, 0.8);
	box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.6);
	z-index: 10;
	cursor: pointer;
	position: absolute;
} */

.result-button {
	/* width: 26%; */
	min-width: 80px;
	height: 2.2rem;
	/* padding: .7rem; */
	border-radius: .4rem;
	border: 2px solid rgb(201, 201, 201);
	background: transparent;
	margin-top: 0%;
	margin-left: 2%;
	font-weight: 600;
	font-size: .75rem;
	color: rgba(0, 0, 0, 0.8);
	/* color: rgba(255, 255, 255, 1); */
	background: rgba(255, 255, 255, 0.6);
	box-shadow: 1px 2px 8px -1px rgba(0, 0, 0, 0.2);
	z-index: 10;
	cursor: pointer;
	position: absolute;
}

#save-variant {
	margin-left: 2%;
}

#visualize-variant {
	margin-left: 32%;
}

#compare-variants {
	margin-left: 58%;
}

#vertical-text-result {
	position: fixed;
	top: 20%;
	right: 0.5%;
	color: rgba(0, 0, 0, 0.5);
	font-size: 1.8rem;
	font-weight: 400;
	line-height: 100%;
	writing-mode: vertical-rl;
	letter-spacing: .2rem;
	text-transform: uppercase;
}



/* -----------------------------------------------------------------------------------------------------
Effects
 ------------------------------------------------------------------------------------------------------- */

/* Buttons */
.result-button:hover {
	-webkit-transform: scale(1.02);
	background: rgba(235, 235, 235, 0.7);
	transform: scale(1.02);
}

.result-button:active {
	background: rgba(235, 235, 235, 0.2);
	transform: translateY(1px);
}

</style>